import React, { useState } from "react";
import classes from "./ProductItemsSelector.module.scss";
import SelectProductItemsHeader from "./header/SelectProductItemsHeader";
import { useRecoilState, useRecoilValue } from "recoil";
import { productItemsState, userState } from "../../../../states/userState";
import { backColorModal, foreColorCode } from "../../../../commons/colors";
import { Divider } from "@mui/material";
import SelectProductItemsMain from "./main/SelectProductItemsMain";
import { productItems as productItemsList } from "../../../../commons/productItems";

const ProductItemsSelector = () => {
  const [productItems, setProductItems] = useRecoilState(productItemsState);
  const [productItemsForUi, setProductItemsForUi] = useState(productItems);
  const user = useRecoilValue(userState);
  const allProdutItems = productItemsList.map((item) => item.id);
  return (
    <div
      className={classes.rootContainer}
      style={backColorModal(user?.mode ?? "lite")}
    >
      <SelectProductItemsHeader
        checkedItems={productItems}
        setCheckedItems={setProductItems}
        allProductItems={allProdutItems}
        checkedItemsForUi={productItemsForUi}
        setCheckedItemsForUi={setProductItemsForUi}
      />
      <Divider
        textAlign="left"
        sx={dividerStyle(
          user?.mode === "lite" ? foreColorCode("lite") : foreColorCode("dark")
        )}
        variant="fullWidth"
      ></Divider>
      <SelectProductItemsMain
        checkedItems={productItems}
        setCheckedItems={setProductItems}
        checkedItemsForUi={productItemsForUi}
        setCheckedItemsForUi={setProductItemsForUi}
      />
    </div>
  );
};
const dividerStyle = (color) => {
  let styles = {
    borderColor: `${color}`, // 線の色をテーマのプライマリーカラーに設定
    fontSize: "18px",
    marginBottom: "0px",
    // Dividerにテキストがある場合、テキストのスタイルもここで定義できます
    "&::before, &::after": {
      // Dividerの線のスタイルをカスタマイズ
      borderTopColor: `${color}`, // これにより、線の色が変わります
    },
    color: `${color}`, // テキストの色を変更
    "@media (max-width: 600px)": {
      fontSize: "14px", // フォントサイズを14pxに設定
    },
  };
  return styles;
};
export default ProductItemsSelector;
